import { render, staticRenderFns } from "./UpdateMdtDisease.vue?vue&type=template&id=4134fb3d&scoped=true"
import script from "./UpdateMdtDisease.vue?vue&type=script&lang=js"
export * from "./UpdateMdtDisease.vue?vue&type=script&lang=js"
import style0 from "./UpdateMdtDisease.vue?vue&type=style&index=0&id=4134fb3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134fb3d",
  null
  
)

export default component.exports